import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/Order"
    },
    {
      path: "/Order",
      name: "Order",
      component: () => import("../components/Order/Order"),
      meta : {keepAlive:true,title: "订单管理"}
    },
    {
      path: "/OrderShow",
      name: "OrderShow",
      component: () => import("../components/Order/OrderShow"),
      meta : {keepAlive:true,title: "查看订单"}
    },
    {
      path: "/OrderTableShow",
      name: "OrderTableShow",
      component: () => import("../components/Order/OrderTableShow"),
      meta : {keepAlive:false,title: "查看订单"}
    },
    {
      path: "/Dev",
      name: "Dev",
      component: () => import("../components/Dev/Dev"),
       meta  : {keepAlive:false,title: "设备管理"}
    },
    {
      path: "/Reporter",
      name: "Reporter",
      component: () => import("../components/Dev/Reporter"),
       meta  : {keepAlive:false,title: "验证报告"}
    },
    {
      path: "/Person",
      name: "Person",
      component: () => import("../components/Person/Person"),
       meta  : {keepAlive:false,title: "个人信息"}
    },
    {
      path: "/EditReporter",
      name: "EditReporter",
      component: () => import("../components/Dev/EditReporter"),
       meta  : {keepAlive:false,title: "编辑验证报告"}
    },
    {
      path: "/Log",
      name: "Log",
      component: () => import("../components/Setting/Log"),
       meta  : {keepAlive:false,title: "日志管理"}
    }, {
      path: "/Company",
      name: "Company",
      component: () => import("../components/Setting/Company"),
       meta  : {keepAlive:false,title: "公司管理"}
    }, {
      path: "/CompanyCreate",
      name: "CompanyCreate",
      component: () => import("../components/Setting/CompanyCreate"),
       meta  : {keepAlive:false,title: "公司创建"}
    }, {
      path: "/PersonCreate",
      name: "PersonCreate",
      component: () => import("../components/Setting/PersonCreate"),
       meta  : {keepAlive:false,title: "验证人员"}
    },

    {
      path: "/DepartmentCreate",
      name: "DepartmentCreate",
      component: () => import("../components/Setting/DepartmentCreate"),
       meta  : {keepAlive:false,title: "部门创建"}
    },

    {
      path: "/Department",
      name: "Department",
      component: () => import("../components/Setting/Department"),
       meta  : {keepAlive:false,title: "部门管理"}
    }, {
      path: "/SettingPerson",
      name: "SettingPerson",
      component: () => import("../components/Setting/Person"),
       meta  : {keepAlive:false,title: "人员管理"}
    }, {
      path: "/Mould",
      name: "Mould",
      component: () => import("../components/Setting/Mould"),
       meta  : {keepAlive:false,title: "模板管理"}
    },
    {
      path: "/Mapto",
      name: "Mapto",
      component: () => import("../components/map/Mapto"),
      meta  : {keepAlive:false,title: "映射管理"}
    },
    {
      path: "/DevMapTo",
      name: "DevMapTo",
      component: () => import("../components/map/DevMapTo"),
      meta  : {keepAlive:false,title: "映射管理"}
    },
    {
      path: "/Box",
      name: "Box",
      component: () => import("../components/Dev/Box"),
       meta  : {keepAlive:false,title: "箱设备列表"}
    },
    {
      path: "/Order/Dev",
      name: "Dev",
      component: () => import("../components/Order/Dev"),
       meta  : {keepAlive:false,title: "设备管理"}
    },
    {
      path: "/OrderAdd",
      name: "OrderAdd",
      component: () => import("../components/Order/OrderAdd"),
       meta  : {keepAlive:false,title: "订单创建"}
    },
    {
      path: "/OrderCreate",
      name: "OrderCreate",
      component: () => import("../components/Order/OrderCreate"),
       meta  : {keepAlive:false,title: "创建验证对象"}
    },
    {
      path: "/OrderTable",
      name: "OrderTable",
      component: () => import("../components/Order/OrderTable"),
       meta  : {keepAlive:false,title: "验证对象一览表"}
    },
    {
      path: "/OrderSubProjects",
      name: "OrderSubProjects",
      component: () => import("../components/Order/OrderSubProjects"),
       meta  : {keepAlive:false,title: "验证内容列表"}
    },
    {
      path: "/OrderSubProjectsShow",
      name: "OrderSubProjectsShow",
      component: () => import("../components/Order/OrderSubProjectsShow"),
       meta  : {keepAlive:false,title: "验证内容列表"}
    },
    {
      path: "/UserEdit",
      name: "UserEdit",
      component: () => import("../components/Order/UserEdit"),
       meta  : {keepAlive:false,title: "编辑客户信息"}
    },
    {
      path: "/GroupEdit",
      name: "GroupEdit",
      component: () => import("../components/Order/GroupEdit"),
       meta  : {keepAlive:false,title: "编辑验证小组"}
    },
    {
      path: "/HistoryCurve",
      name: "HistoryCurve",
      component: () => import("../components/Order/HistoryCurve"),
       meta  : {keepAlive:false,title: "原始数据曲线"}
    },
    {
      path: "/HistoryCurveOnlyTemOrHum",
      name: "HistoryCurveOnlyTemOrHum",
      component: () => import("../components/Order/HistoryCurveOnlyTemOrHum"),
       meta  : {keepAlive:false,title: "原始数据曲线"}
    },
    {
      path: "/HistoryList",
      name: "HistoryList",
      component: () => import("../components/Order/HistoryList"),
       meta  : {keepAlive:false,title: "历史数据列表"}
    },
    {
      path: "/Distribution",
      name: "Distribution",
      component: () => import("../components/Order/Distribution"),
       meta  : {keepAlive:false,title: "布点图"}
    }, {
      path: "/Analysis",
      name: "Analysis",
      component: () => import("../components/Order/Analysis"),
       meta  : {keepAlive:false,title: "数据分析"}
    }, {
      path: "/AverageCurve",
      name: "AverageCurve",
      component: () => import("../components/Order/AverageCurve"),
       meta  : {keepAlive:false,title: "点位平均温度曲线"}
    }, {
      path: "/DataCurve",
      name: "DataCurve",
      component: () => import("../components/Order/DataCurve"),
       meta  : {keepAlive:false,title: "曲线数据"}
    }, {
      path: "/DataList",
      name: "DataList",
      component: () => import("../components/Order/DataList"),
       meta  : {keepAlive:false,title: "历史数据"}
    }, {
      path: "/DataAnalysis",
      name: "DataAnalysis",
      component: () => import("../components/Order/DataAnalysis"),
       meta  : {keepAlive:false,title: "数据分析"}
    }, {
      path: "/DataAverageCurve",
      name: "DataAverageCurve",
      component: () => import("../components/Order/DataAverageCurve"),
       meta  : {keepAlive:false,title: "点位平均温度曲线"}
    }, {
      path: "/DataAnalysisTwo",
      name: "DataAnalysisTwo",
      component: () => import("../components/Order/DataAnalysis"),
       meta  : {keepAlive:false,title: "合理性数据分析"}
    }, {
      path: "/EditDataCurve",
      name: "EditDataCurve",
      component: () => import("../components/Order/EditDataCurve"),
       meta  : {keepAlive:false,title: "批量编辑数据"}
    }, {
      path: "/SubSetup",
      name: "SubSetup",
      component: () => import("../components/Order/SubSetup"),
       meta  : {keepAlive:false,title: "详情设置"}
    }, {
      path: "/BindPoint",
      name: "BindPoint",
      component: () => import("../components/Order/BindPoint"),
       meta  : {keepAlive:false,title: "绑定点位"}
    }, {
      path: "/BindDev",
      name: "BindDev",
      component: () => import("../components/Order/BindDev"),
       meta  : {keepAlive:false,title: "终端设备绑定"}
    }, {
      path: "/ChooseDev",
      name: "ChooseDev",
      component: () => import("../components/Order/ChooseDev"),
       meta  : {keepAlive:false,title: "选择设备"}
    }, {
      path: "/NowView",
      name: "NowView",
      component: () => import("../components/Order/NowView"),
       meta  : {keepAlive:false,title: "实时视图"}
    }, {
      path: "/NowCurve",
      name: "NowCurve",
      component: () => import("../components/Order/NowCurve"),
       meta  : {keepAlive:false,title: "实时曲线"}
    }, {
      path: "/Progress",
      name: "/Progress",
      component: () => import("../components/Order/Progress"),
       meta  : {keepAlive:false,title: "验证进度表"}
    }, {
      path: "/DataChoose",
      name: "/DataChoose",
      component: () => import("../components/Order/DataChoose"),
       meta  : {keepAlive:false,title: "资料库选择"}
    },
    {
      path: "/AssignOrderList",
      name: "/AssignOrderList",
      component: () => import("../components/Order/AssignOrderList"),
       meta  : {keepAlive:false,title: "分配订单列表"}
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js